var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"excalidrawModalWrapper"}},[(_vm.open && _vm.roomUrl)?_c('ExcalidrawModal',{attrs:{"board-url":_vm.roomUrl},on:{"close":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }